import MultiChoiceSearchField from '../components/filters/MultiChoiceSearchField';
import Calendar from '../components/filters/Calendar';
import CustomCheckbox from '../components/filters/CustomCheckbox';
import ListCombo from '../components/filters/ListCombo';
import '../css/LocalFilters.css';

const AirdnaFilters = ({ query, app }) => {
    const filterStorageKey = (query) ? query : 'airdna';
    const comboApplication = app || 'airdna';
    const category = 'filters';

    return (
        <div className="local-filters-widget">
            <section className="local-filters-section">
                <div className="local-filters-section-header">
                    <div>
                        <h3 className="local-filters-section-title">Période</h3>
                        <p className="local-filters-section-description">Choisissez l'année de référence des données Airdna.</p>
                    </div>
                </div>
                <div className="local-filter-field">
                    <Calendar
                        application={filterStorageKey}
                        category={category}
                        name="periode"
                        views="year"
                        label="Année"
                    />
                </div>
            </section>

            <section className="local-filters-section">
                <div className="local-filters-section-header">
                    <div>
                        <h3 className="local-filters-section-title">Territoires</h3>
                        <p className="local-filters-section-description">Filtrez par bassins ou communes selon le niveau d'analyse souhaité.</p>
                    </div>
                </div>
                <div className="local-filters-grid local-filters-grid--two">
                    <div className="local-filter-field">
                        <MultiChoiceSearchField
                            application={filterStorageKey}
                            comboApplication={comboApplication}
                            category={category}
                            name="area_medium"
                            label="Bassins"
                            source="group"
                            area="epci, zone, observatoire"
                        />
                    </div>
                    <div className="local-filter-field">
                        <MultiChoiceSearchField
                            application={filterStorageKey}
                            comboApplication={comboApplication}
                            category={category}
                            name="area_small"
                            label="Villes"
                            source="entity"
                            area="commune"
                        />
                    </div>
                </div>
            </section>

            <section className="local-filters-section">
                <div className="local-filters-section-header">
                    <div>
                        <h3 className="local-filters-section-title">Statut des annonces</h3>
                        <p className="local-filters-section-description">Limitez les résultats aux annonces réservées, actives ou professionnelles.</p>
                    </div>
                </div>
                <div className="local-filters-grid local-filters-grid--compact">
                    <div className="local-filter-check">
                        <CustomCheckbox application={filterStorageKey} category={category} name="oneResa" label="Au moins 1 résa dans le mois" />
                    </div>
                    <div className="local-filter-check">
                        <CustomCheckbox application={filterStorageKey} category={category} name="active" label="Annonces actives" />
                    </div>
                    <div className="local-filter-check">
                        <CustomCheckbox application={filterStorageKey} category={category} name="professional" label="Annonces professionnelles" />
                    </div>
                </div>
            </section>

            <section className="local-filters-section">
                <div className="local-filters-section-header">
                    <div>
                        <h3 className="local-filters-section-title">Logements</h3>
                        <p className="local-filters-section-description">Affinez la typologie, la propriété et la capacité d'accueil.</p>
                    </div>
                </div>
                <div className="local-filters-grid local-filters-grid--three">
                    <div className="local-filter-field">
                        <ListCombo application={filterStorageKey} comboApplication={comboApplication} category={category} name="listingType" label="Type de logement" multiple={true} source="listing_type" labelField="label_fr" />
                    </div>
                    <div className="local-filter-field">
                        <ListCombo application={filterStorageKey} comboApplication={comboApplication} category={category} name="propertyType" label="Type de propriété" multiple={true} source="prop_type_requalif" />
                    </div>
                    <div className="local-filter-field">
                        <ListCombo application={filterStorageKey} comboApplication={comboApplication} category={category} name="maxGuests" label="Capacité d'accueil" multiple={true} source="nbguest_list" />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AirdnaFilters;
